export default __webpack_public_path__ + "static/banner-wedding-on-a-budget-36c7ce236822fcc70116b42394617cfe.jpg";